/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar29 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar29", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 10.935547 14.306641 C 12.512547 14.306641 13.566406 15.151484 13.566406 16.396484 C 13.566406 17.177484 13.107422 17.871375 11.857422 18.984375 L 10.695312 20.052734 L 10.695312 20.146484 L 13.664062 20.146484 L 13.664062 21.542969 L 8.3085938 21.542969 L 8.3085938 20.347656 L 10.535156 18.251953 C 11.570156 17.294953 11.835938 16.939437 11.835938 16.523438 C 11.835938 16.005437 11.454047 15.658203 10.873047 15.658203 C 10.268047 15.658203 9.8476563 16.069391 9.8476562 16.650391 L 9.8476562 16.683594 L 8.2050781 16.683594 L 8.2050781 16.654297 C 8.2050781 15.253297 9.3005469 14.306641 10.935547 14.306641 z M 18.712891 14.308594 C 19.708891 14.308594 20.524016 14.713172 21.041016 15.451172 C 21.515016 16.086172 21.763672 16.959141 21.763672 17.994141 C 21.764672 20.302141 20.598125 21.728516 18.703125 21.728516 C 17.287125 21.728516 16.168422 20.904891 15.982422 19.712891 L 17.736328 19.712891 C 17.848328 20.103891 18.233891 20.351562 18.712891 20.351562 C 19.581891 20.351562 20.134313 19.454391 20.070312 18.150391 L 20.021484 18.150391 L 19.976562 18.150391 C 19.659562 18.804391 19.030844 19.171875 18.214844 19.171875 C 16.881844 19.171875 15.894531 18.185656 15.894531 16.847656 C 15.894531 15.363656 17.062891 14.308594 18.712891 14.308594 z M 18.728516 15.689453 C 18.103516 15.689453 17.615234 16.171969 17.615234 16.792969 C 17.615234 17.417969 18.094516 17.886719 18.728516 17.886719 C 19.358516 17.886719 19.835937 17.418828 19.835938 16.798828 C 19.835937 16.172828 19.353516 15.689453 18.728516 15.689453 z" />
      </svg>
    );
  }
}

IconCalendar29.defaultProps = {
  className: null
};

IconCalendar29.propTypes = {
  className: PropTypes.string
};

export default IconCalendar29;
